import React from 'react';
import styles from './employee-schedule-card.module.scss';
import {
  IEmployee,
  IEmployeeDay,
} from 'shared/api/booking/interfaces/get-employees-month-schedule.interface';
import { EmployeeWeeklySchedule } from 'features/employee-weekly-schedule';
import { CircleImage } from 'shared/ui';

interface IEmployeeScheduleCardProps {
  employee: IEmployee;
  currentDate: Date;
  onDayClick?: (employeeId: string, day: IEmployeeDay, dayDate: Date) => void;
}

export const EmployeeScheduleCard: React.FC<IEmployeeScheduleCardProps> = ({
  employee,
  currentDate,
  onDayClick,
}) => {
  const handleDayClick = (day: IEmployeeDay, dayDate: Date) => {
    onDayClick?.(employee.id, day, dayDate);
  };

  return (
    <div className={styles.card}>
      <div className={styles.card__info}>
        <CircleImage imgSrc={employee.imgUrl} imgSize={42} />
        <div className={styles.info__name}>{employee.fio}</div>
      </div>
      <div className={styles.card__schedule}>
        <EmployeeWeeklySchedule
          days={employee.days}
          currentDate={currentDate}
          onDayClick={handleDayClick}
        />
      </div>
    </div>
  );
};
